/*
  "View more" for Selleasy's product-page add-on list (widget#cpal, e.g. "Make Your City Even More
  Epic With These!"). The app renders up to ~20 cards as lb-upsell-flat-card children of a .lb-list,
  inside the theme's app block div.lb-widget-cpal. Long lists push the page down, mostly on mobile.

  The app re-renders its own markup (Stencil), so nothing inside it is touched: the collapsed state is
  a class on the theme-owned block div and the cards beyond the first VISIBLE are hidden with CSS
  (assets/custom.css). The button sits after the block div, outside the app's markup.
*/
(() => {
  const VISIBLE = 3;
  const CARD_SELECTOR = '.lb-list > lb-upsell-flat-card, .lb-list > lb-upsell-long-card';

  const sync = (block) => {
    const count = block.querySelectorAll(CARD_SELECTOR).length;
    let button = block.nextElementSibling;
    if (!button || !button.matches('[data-upsell-view-more]')) button = null;

    if (count <= VISIBLE) {
      block.classList.remove('upsell-collapsed');
      if (button) button.hidden = true;
      return;
    }

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'upsell-view-more';
      button.setAttribute('data-upsell-view-more', '');
      button.addEventListener('click', () => {
        block.dataset.upsellExpanded = block.dataset.upsellExpanded === 'true' ? 'false' : 'true';
        sync(block);
        if (block.dataset.upsellExpanded === 'false') block.scrollIntoView({ block: 'nearest' });
      });
      block.after(button);
    }

    const expanded = block.dataset.upsellExpanded === 'true';
    block.classList.toggle('upsell-collapsed', !expanded);
    button.hidden = false;
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? 'View less' : `View more (${count - VISIBLE})`;
  };

  const watch = (block) => {
    if (block.dataset.upsellWatched) return;
    block.dataset.upsellWatched = 'true';
    sync(block);
    new MutationObserver(() => sync(block)).observe(block, { childList: true, subtree: true });
  };

  const init = () => document.querySelectorAll('.lb-widget-cpal').forEach(watch);

  init();
  // Product pages re-render sections (variant changes, quick view); pick up new blocks, once per frame.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      init();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
